import {Component} from "@angular/core";
import {SizeGroupRelationSearchModel} from "../size-group-relation-search.model";
import {SizeGroupRelationEntityModel} from "../size-group-relation-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-size-group-relation-search-page",
    templateUrl: "./size-group-relation-search-page.component.html",
    providers: [provideSearchModel(SizeGroupRelationSearchModel), provideEntityModel(SizeGroupRelationEntityModel)]
})
export class SizeGroupRelationSearchPageComponent extends AbstractSearchPage {
}
